import "./PartnerMangmentListing.css";
import { message, Table } from 'antd';
import { Link, Navigate } from 'react-router-dom';
import { SaveOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { Dropdown } from "antd";
import { Menu } from "antd";
import { Payout_Service } from "../../../redux/Url";
import { Spin } from "antd";
import useSession from "../../CustomLogout/useSession";

export const PayoutManagmentListingChanalwise = (props) => {
  const {
    dataSource,
    pagination,
    // onChange,
    loading,
    handelSubmit,

  } = props;
  const [downloading, setDownloading] = useState(false);
  const handleSessionExpired = useSession();


  // Support both array and object with content property
  useEffect(() => {
  }, [dataSource]);
  const tableData = Array.isArray(dataSource)
    ? dataSource
    : dataSource || [];

  const mappedTableData = tableData.map((item, index) => ({
    ...item,
    // "GeneratedDate": item.createdAt
    //   ? new Date(item.createdAt).toISOString().slice(0, 10)
    //   : '',
  }));

  const headerMenu = (reportId) => (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key, reportId)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Hold Payout(Bulk Action)', key: 'HoldPayoutBulk' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
      ]}
    />
  );

  const handleHeaderMenuClick = (key, reportId) => {
    switch (key) {
      case 'ExportCSV':
        downloadReport('csv', reportId);
        break;
      case 'ExportExcel':
        downloadReport('excel', reportId);
        break;
      default:
        break;
    }
  };

  const downloadReport = async (format, reportId) => {
    setDownloading(true); // Show loading indicator
    try {
      const response = await
        fetch(
          `${Payout_Service}/reports/payout-channel-report-export?monthlyReportId=${reportId}&format=${format}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + props.accessToken,
            },
          }
        );
      const errorCode = response.status;
      if (errorCode === 403) {
        handleSessionExpired(); //Logout the user if session expired
        setDownloading(false);
        return;
      }
      if (!response.ok) throw new Error('Network response was not ok');



      // console.log('Response received for download:', response);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    } finally {
      setDownloading(false); // Hide loading indicator
    }
  };

  const columns = [
    {
      title: 'File Name',
      dataIndex: 'fileName',
      key: 'fileName',
      render: (_, payoutgrp) => (
        // <Link to={`Details/${payoutgrp.fileName}/${payoutgrp.monthlyReportId}`} style={{ color: "#1b8593", textDecoration: 'none' }}>
        <Link to={`Details/${payoutgrp.fileName}/${payoutgrp.reportId}`}
          state={{ filestatus: payoutgrp.status }}
          style={{ color: "#1b8593", textDecoration: 'none' }}>
          {payoutgrp.fileName}
        </Link>
      ),
      fixed: "left",
    },
    {
      title: 'Generated Date', dataIndex: 'generatedDate', key: 'generatedDate',
      // render: (text) => new Date(text).toLocaleDateString() 
    },
    { title: 'User Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Records in File', dataIndex: 'totalRecords', key: 'totalRecords' },
    {
      title: 'Total Disb. Amount', dataIndex: 'totalDisbursedAmount', key: 'totalDisbursedAmount',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Partner Records', dataIndex: 'partnerRecords', key: 'partnerRecords' },
    {
      title: 'Partner Total Dis Amount', dataIndex: 'partnerTotalDisbursedAmount', key: 'partnerTotalDisbursedAmount',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    { title: 'Non Partner Records', dataIndex: 'nonPartnerRecords', key: 'nonPartnerRecords' },
    {
      title: 'Non Partner Total Dis Amount', dataIndex: 'nonPartnerTotalDisbursedAmount', key: 'nonPartnerTotalDisbursedAmount',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (_, payoutgrp) => (
        <Dropdown overlay={headerMenu(payoutgrp.reportId)} trigger={['click']}>
          <span style={{ color: 'black', fontSize: '18px' }}>
            <UnorderedListOutlined />
          </span>
        </Dropdown>
      )

    }
  ];

  return (
    <div style={{ maxWidth: '100%' }}>
      {downloading && (
        <div style={{
          position: 'absolute',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin tip="Downloading..." size="large" />
        </div>
      )}
      <Table
        style={{ marginTop: "20px" }}
        dataSource={mappedTableData}
        columns={columns}
        scroll={{ x: "max-content" }}
        pagination={false}
        // onChange={onChange}
        loading={loading}
        rowKey="fileName" // or another unique key
      />
    </div>
  );
}



const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PayoutManagmentListingChanalwise)